document.addEventListener("turbolinks:load", () => {
  $(".selected_event_kind").change(function () {
    const selectedOption = $(".selected_event_kind").val();
    const videoID = $(".selected_event_kind").data("video-id");

    if (selectedOption === "key_incident") {
      $.ajax({
        url: `/video_centre/${videoID}/key_incidents`,
        type: "GET",
      });
    } else if (selectedOption === "competency") {
      $.ajax({
        url: `/video_centre/${videoID}/competencies`,
        type: "GET",
      });
    } else if (selectedOption === "caution") {
      $.ajax({
        url: `/video_centre/${videoID}/cautions`,
        type: "GET",
      });
    } else if (selectedOption === "club_feedback") {
      $.ajax({
        url: `/video_centre/${videoID}/club_feedback`,
        type: "GET",
      });
    } else if (selectedOption === "clips") {
      $.ajax({
        url: `/video_centre/${videoID}/clips_dropdown`,
        type: "GET",
      });
    }
  });

  $("#video_centre_customer_id_eq").change(function () {
    customerID = $("#video_centre_customer_id_eq").val();

    if (customerID) {
      window.filter_form.showCompetitions(customerID);
      window.filter_form.showSeasons(customerID);
    } else {
      $("#q_competition_id_eq").find("option").remove();

      $("#q_competition_id_eq").append(`<option value=""></option>`);

      $("#q_season_id_eq").find("option").remove();

      $("#q_season_id_eq").append(`<option value=""></option>`);
    }
  });

  // Only apply clickable-row behavior if NOT on a playlist show page (individual playlist)
  // Allow clickable rows on playlist index pages (favorites, shared_with_me, etc.)
  // if (!window.location.pathname.match(/\/video_centre\/playlists\/\d+$/)) {
    
  //   // Handle clickable rows for playlist index pages
  //   $(document).on("click", "td", function (e) {
  //     // Check if this td has clickable-row class and handle navigation
  //     if ($(this).hasClass('clickable-row')) {
  //       href = $(this).data("href");
  //       isRemote = $(this).data("remote");
        
  //       if (href) {
  //         if (isRemote) {
  //           // Make AJAX request with CSRF token
  //           $.ajax({
  //             url: href,
  //             headers: {
  //               'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
  //             }
  //           });
  //         } else {
  //           window.location = href;
  //         }
  //       }
  //     }
  //   });
  // } else {
  //   // Individual playlist show page - skip clickable-row behavior
  // }

  $(".clickable-row").off("mouseenter mouseleave");
  
  $(".clickable-row").hover(
    function () {
      $(this).addClass("table-hover-row");
    },
    function () {
      $(this).removeClass("table-hover-row");
    }
  );

  // Use event delegation for favorite icons to work with dynamically loaded content
  $(document).off('click', '.favorite-icon');
  
  $(document).on('click', '.favorite-icon', function(e) {
    e.stopPropagation();
    
    const $icon = $(this).find('i');
    const observationId = $(this).data('observation-id');
    const observationClipId = $(this).data('observation-clip-id');
    const clubFeedbackObservationId = $(this).data('club-feedback-observation-id');
    const playlistId = $(this).data('playlist-id');
    const videoId = $(this).data('video-id');
    const fixtureId = $(this).data('fixture-id');
    
    if (observationClipId) {
      const isFavorited = $icon.data('favorited');
      const url = `/observation_clips/${observationClipId}/favorites`;
      const method = isFavorited ? 'DELETE' : 'POST';
      
      $.ajax({
        url: url,
        method: method,
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
          if (response.favorited) {
            $icon.removeClass('far text-muted').addClass('fas text-danger');
            $icon.data('favorited', true);
          } else {
            $icon.removeClass('fas text-danger').addClass('far text-muted');
            $icon.data('favorited', false);
          }
          
          toastr.info(response.message, '', { 
            'closeButton': true, 
            'progressBar': true, 
            'positionClass': 'toast-top-center' 
          });
        },
        error: function() {
          toastr.error(window.translations.favorites.error_processing_favorite, '', { 
            'closeButton': true, 
            'progressBar': true, 
            'positionClass': 'toast-top-center' 
          });
        }
      });
      return;
    }
    
    if (videoId) {
      const isFavorited = $icon.data('favorited');
      const url = `/fixtures/${fixtureId}/videos/${videoId}/favorites`;
      const method = isFavorited ? 'DELETE' : 'POST';
      
      $.ajax({
        url: url,
        method: method,
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
          if (response.favorited) {
            $icon.removeClass('far text-muted').addClass('fas text-danger');
            $icon.data('favorited', true);
          } else {
            $icon.removeClass('fas text-danger').addClass('far text-muted');
            $icon.data('favorited', false);
          }
          
          toastr.info(response.message, '', { 
            'closeButton': true, 
            'progressBar': true, 
            'positionClass': 'toast-top-center' 
          });
        },
        error: function() {
          toastr.error(window.translations.favorites.error_processing_favorite, '', { 
            'closeButton': true, 
            'progressBar': true, 
            'positionClass': 'toast-top-center' 
          });
        }
      });
      return;
    }

    if (clubFeedbackObservationId) {
      const isFavorited = $icon.data('favorited');
      const url = `/club_feedback_observations/${clubFeedbackObservationId}/favorites`;
      const method = isFavorited ? 'DELETE' : 'POST';
      
      $.ajax({
        url: url,
        method: method,
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
          if (response.favorited) {
            $icon.removeClass('far text-muted').addClass('fas text-danger');
            $icon.data('favorited', true);
          } else {
            $icon.removeClass('fas text-danger').addClass('far text-muted');
            $icon.data('favorited', false);
          }
          
          toastr.info(response.message, '', { 
            'closeButton': true, 
            'progressBar': true, 
            'positionClass': 'toast-top-center' 
          });
        },
        error: function() {
          toastr.error(window.translations.favorites.error_processing_favorite, '', { 
            'closeButton': true, 
            'progressBar': true, 
            'positionClass': 'toast-top-center' 
          });
        }
      });
      return;
    }
    
    if (observationId) {
      const isFavorited = $icon.data('favorited');
      const url = isFavorited ? 
        `/appointments/${fixtureId}/observations/${observationId}/favorites` : 
        `/appointments/${fixtureId}/observations/${observationId}/favorites`;
      const method = isFavorited ? 'DELETE' : 'POST';
      
      $.ajax({
        url: url,
        method: method,
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
          if (response.favorited) {
            $icon.removeClass('far text-muted').addClass('fas text-danger');
            $icon.data('favorited', true);
          } else {
            $icon.removeClass('fas text-danger').addClass('far text-muted');
            $icon.data('favorited', false);
          }
          
          toastr.info(response.message, '', { 
            'closeButton': true, 
            'progressBar': true, 
            'positionClass': 'toast-top-center' 
          });
        },
        error: function() {
          toastr.error(window.translations.favorites.error_processing_favorite, '', { 
            'closeButton': true, 
            'progressBar': true, 
            'positionClass': 'toast-top-center' 
          });
        }
      });
      return;
    }
    
    if (playlistId) {
      const isFavorited = $icon.data('favorited');
      const url = `/video_centre/playlists/${playlistId}/favorites`;
      const method = isFavorited ? 'DELETE' : 'POST';
      
      $.ajax({
        url: url,
        method: method,
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
          if (response.favorited) {
            $icon.removeClass('far text-muted').addClass('fas text-danger');
            $icon.data('favorited', true);
          } else {
            $icon.removeClass('fas text-danger').addClass('far text-muted');
            $icon.data('favorited', false);
          }
          
          toastr.info(response.message, '', { 
            'closeButton': true, 
            'progressBar': true, 
            'positionClass': 'toast-top-center' 
          });
        },
        error: function() {
          toastr.error(window.translations.favorites.error_processing_favorite, '', { 
            'closeButton': true, 
            'progressBar': true, 
            'positionClass': 'toast-top-center' 
          });
        }
      });
      return;
    }
    
    if (!videoId) {
      toastr.warning(window.translations.favorites.video_not_available, '', { 
        'closeButton': true, 
        'progressBar': true, 
        'positionClass': 'toast-top-center' 
      });
      return;
    }
    
    const isFavorited = $icon.data('favorited');
    const url = isFavorited ? 
      `/fixtures/${fixtureId}/videos/${videoId}/favorites` : 
      `/fixtures/${fixtureId}/videos/${videoId}/favorites`;
    const method = isFavorited ? 'DELETE' : 'POST';
    
    $.ajax({
      url: url,
      method: method,
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function(response) {
        if (response.favorited) {
          $icon.removeClass('far text-muted').addClass('fas text-danger');
          $icon.data('favorited', true);
        } else {
          $icon.removeClass('fas text-danger').addClass('far text-muted');
          $icon.data('favorited', false);
        }
        
        toastr.info(response.message, '', { 
          'closeButton': true, 
          'progressBar': true, 
          'positionClass': 'toast-top-center' 
        });
      },
      error: function() {
        toastr.error(window.translations.favorites.error_processing_favorite, '', { 
          'closeButton': true, 
          'progressBar': true, 
          'positionClass': 'toast-top-center' 
        });
      }
    });
  });

  // Use event delegation for share icons to work with dynamically loaded content
  $(document).off('click.sharing', '.share-icon');
  
  $(document).on('click.sharing', '.share-icon', function(e) {
    e.stopPropagation();
    e.preventDefault();

    const $this = $(this);
    const videoId = $this.data('video-id');
    const observationId = $this.data('observation-id');
    const fixtureId = $this.data('fixture-id');

    try {
      if (videoId) {
        openSharingModalForVideo(videoId, fixtureId);
      } else if (observationId) {
        openSharingModalForObservation(observationId, fixtureId);
      }
    } catch (error) {
      console.error('Erro ao abrir modal de compartilhamento:', error);
      toastr.error('Erro ao abrir janela de compartilhamento');
    }
  });

  function openSharingModalForVideo(videoId, fixtureId) {
    const sharingModal = $('#sharing-modal');
    if (sharingModal.length) {
      sharingModal
        .attr('data-video-id', videoId)
        .attr('data-fixture-id', fixtureId)
        .attr('data-sharing-mode', 'video')
        .modal('show');
    }
  }

  function openSharingModalForObservation(observationId, fixtureId) {
    const sharingModal = $('#sharing-modal');
    if (sharingModal.length) {
      sharingModal
        .attr('data-observation-id', observationId)
        .attr('data-fixture-id', fixtureId)
        .attr('data-sharing-mode', 'observation')
        .modal('show');
    }
  }

  // Checkbox functionality for bulk operations
  var selectAll = document.getElementById('select-all-clips');
  var selectAllDownloads = document.getElementById('select-all-downloads');
  var selectAllVideos = document.getElementById('select-all-videos');
  var checkboxes = document.querySelectorAll('.clip-checkbox');
  var videoCheckboxes = document.querySelectorAll('.video-checkbox');
  var blockMenusSpecial = document.querySelector('.blockMenusSpecial');
  var shareBtn = document.getElementById('shareClipsBtn');

  function updateBlockMenusSpecial(e) {
    var checkedCount = document.querySelectorAll('.clip-checkbox:checked').length;
    var checkedVideoCount = document.querySelectorAll('.video-checkbox:checked').length;
    var totalChecked = checkedCount + checkedVideoCount;
    
    if (blockMenusSpecial) {
      if (totalChecked >= 1) {
        blockMenusSpecial.classList.remove('d-none');
      } else {
        blockMenusSpecial.classList.add('d-none');
      }
    }
    
    // Update table row hover classes for checked checkboxes
    checkboxes.forEach(function(checkbox) {
      var tableRow = checkbox.closest('tr');
      if (tableRow) {
        if (checkbox.checked) {
          tableRow.classList.add('table-row-hover');
        } else {
          tableRow.classList.remove('table-row-hover');
        }
      }
    });
    
    // Update table row hover classes for checked video checkboxes
    videoCheckboxes.forEach(function(checkbox) {
      var tableRow = checkbox.closest('tr');
      if (tableRow) {
        if (checkbox.checked) {
          tableRow.classList.add('table-row-hover');
        } else {
          tableRow.classList.remove('table-row-hover');
        }
      }
    });
    
    return false;
  }

  // Handle select all for clips page
  if (selectAll) {
    selectAll.addEventListener('change', function() {
      checkboxes.forEach(function(checkbox) {
        checkbox.checked = selectAll.checked;
      });
      updateBlockMenusSpecial();
    });
  }

  // Handle select all for downloads page
  if (selectAllDownloads) {
    selectAllDownloads.addEventListener('change', function() {
      checkboxes.forEach(function(checkbox) {
        checkbox.checked = selectAllDownloads.checked;
      });
      updateBlockMenusSpecial();
    });
  }

  // Handle select all for videos page
  if (selectAllVideos) {
    selectAllVideos.addEventListener('change', function() {
      videoCheckboxes.forEach(function(checkbox) {
        checkbox.checked = selectAllVideos.checked;
      });
      updateBlockMenusSpecial();
    });
  }

  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', updateBlockMenusSpecial);
  });

  videoCheckboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', updateBlockMenusSpecial);
  });

  // Initial state
  updateBlockMenusSpecial();

  // Bulk favorite button action for videos
  $('.bulk-favorite-btn').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const checkedBoxes = document.querySelectorAll('.video-checkbox:checked');
    if (checkedBoxes.length === 0) {
      toastr.warning('Please select videos to favorite', '', {
        'closeButton': true,
        'progressBar': true,
        'positionClass': 'toast-top-center'
      });
      return;
    }
    
    const videoIds = Array.from(checkedBoxes).map(function(checkbox) {
      return checkbox.value;
    });
    
    // Get fixture ID from the first checked video (assuming all videos are from same fixture)
    const firstCheckedBox = checkedBoxes[0];
    const tableRow = firstCheckedBox.closest('tr');
    const fixtureId = tableRow.querySelector('[data-fixture-id]')?.getAttribute('data-fixture-id');
    
    if (!fixtureId) {
      toastr.error('Could not determine fixture ID', '', {
        'closeButton': true,
        'progressBar': true,
        'positionClass': 'toast-top-center'
      });
      return;
    }
    
    // Favorite each video
    let successCount = 0;
    let errorCount = 0;
    
    const favoritePromises = videoIds.map(function(videoId) {
      return $.ajax({
        url: `/fixtures/${fixtureId}/videos/${videoId}/favorites`,
        method: 'POST',
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      }).then(function() {
        successCount++;
      }).catch(function() {
        errorCount++;
      });
    });
    
    Promise.all(favoritePromises).then(function() {
      if (successCount > 0) {
        toastr.success(`Successfully favorited ${successCount} videos`, '', {
          'closeButton': true,
          'progressBar': true,
          'positionClass': 'toast-top-center'
        });
      }
      if (errorCount > 0) {
        toastr.warning(`${errorCount} videos could not be favorited`, '', {
          'closeButton': true,
          'progressBar': true,
          'positionClass': 'toast-top-center'
        });
      }
      
      // Uncheck all checkboxes
      checkedBoxes.forEach(function(checkbox) {
        checkbox.checked = false;
      });
      updateBlockMenusSpecial();
    });
  });

  // Bulk share button action for videos
  $('.bulk-share-btn').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const checkedBoxes = document.querySelectorAll('.video-checkbox:checked');
    if (checkedBoxes.length === 0) {
      toastr.warning('Please select videos to share', '', {
        'closeButton': true,
        'progressBar': true,
        'positionClass': 'toast-top-center'
      });
      return;
    }
    
    const videoIds = Array.from(checkedBoxes).map(function(checkbox) {
      return checkbox.value;
    });
    
    // Open the sharing modal for bulk sharing
    var sharingModal = document.getElementById('sharing-modal');
    if (sharingModal) {
      sharingModal.setAttribute('data-bulk-video-ids', JSON.stringify(videoIds));
      sharingModal.setAttribute('data-sharing-mode', 'bulk-videos');
      $(sharingModal).modal('show');
    }
  });

  // Share button action
  if (shareBtn) {
    shareBtn.addEventListener('click', function() {
      var checkedBoxes = document.querySelectorAll('.clip-checkbox:checked');
      if (checkedBoxes.length > 0) {
        var clipIds = Array.from(checkedBoxes).map(function(checkbox) {
          return checkbox.value;
        });
        
        // Open the sharing modal
        var sharingModal = document.getElementById('sharing-modal');
        if (sharingModal) {
          // Set the clip ids for bulk sharing
          sharingModal.setAttribute('data-bulk-clip-ids', JSON.stringify(clipIds));
          sharingModal.setAttribute('data-sharing-mode', 'bulk');
          $(sharingModal).modal('show');
        }
      }
    });
  }

  // Bulk playlist button action
  $('.add-to-playlist-btn-bulk').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const button = $(this);
    const dropdown = button.closest('.input-group').find('.playlist-select');
    const playlistId = dropdown.val();
    
    if (!playlistId) {
      toastr.warning('Please select a playlist', '', {
        'closeButton': true,
        'progressBar': true,
        'positionClass': 'toast-top-center'
      });
      return;
    }
    
    const checkedBoxes = document.querySelectorAll('.clip-checkbox:checked');
    if (checkedBoxes.length === 0) {
      toastr.warning('Please select clips to add to playlist', '', {
        'closeButton': true,
        'progressBar': true,
        'positionClass': 'toast-top-center'
      });
      return;
    }
    
    const clipData = Array.from(checkedBoxes).map(function(checkbox) {
      return {
        id: checkbox.value,
        type: checkbox.dataset.clipType || 'ObservationClip'
      };
    });
    
    button.prop('disabled', true);
    
    $.ajax({
      url: '/video_centre/bulk_playlist_items',
      type: 'POST',
      data: {
        playlist_id: playlistId,
        clip_data: clipData
      },
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function(response) {
        if (response.success_count > 0) {
          toastr.success(`Successfully added ${response.success_count} clips to playlist`, '', {
            'closeButton': true,
            'progressBar': true,
            'positionClass': 'toast-top-center'
          });
        }
        if (response.error_count > 0) {
          toastr.warning(`${response.error_count} clips could not be added (may already exist in playlist)`, '', {
            'closeButton': true,
            'progressBar': true,
            'positionClass': 'toast-top-center'
          });
        }
        dropdown.val('');
        // Uncheck all checkboxes
        checkedBoxes.forEach(function(checkbox) {
          checkbox.checked = false;
        });
        updateBlockMenusSpecial();
      },
      error: function(xhr) {
        let message = 'Error adding clips to playlist';
        if (xhr.responseJSON && xhr.responseJSON.error) {
          message = xhr.responseJSON.error;
        }
        toastr.error(message, '', {
          'closeButton': true,
          'progressBar': true,
          'positionClass': 'toast-top-center'
        });
      },
      complete: function() {
        button.prop('disabled', false);
      }
    });
  });

  // Initialize Bootstrap dropdowns for menu-plus buttons
  $('[data-toggle="dropdown"]').dropdown();
  
  // Alternative approach: manually handle dropdown toggle
  $(document).on('click', '[data-toggle="dropdown"]', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    var $this = $(this);
    var $dropdown = $this.next('.dropdown-menu');
    
    // Close other dropdowns
    $('.dropdown-menu').not($dropdown).removeClass('show');
    
    // Toggle current dropdown
    $dropdown.toggleClass('show');
    
    // Update aria-expanded
    $this.attr('aria-expanded', $dropdown.hasClass('show'));
  });
  
  // Close dropdowns when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.dropdown').length) {
      $('.dropdown-menu').removeClass('show');
      $('[data-toggle="dropdown"]').attr('aria-expanded', 'false');
    }
  });

  $('body').on('click', 'td.clickable-row', function (e) {
    var href = $(this).data("href");
    var isRemote = $(this).data("remote");
    if (href) {
      if (isRemote) {
        $.ajax({
          url: href,
          headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
          }
        });
      } else {
        window.location = href;
      }
    }
  });

  // Function to delete clip
  window.deleteClip = function(clipId, clipType) {
    if (!confirm('Are you sure you want to delete this clip?')) {
      return;
    }

    $.ajax({
      url: `/clips/${clipId}/destroy`,
      method: 'DELETE',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function(response) {
        if (response.success) {
          toastr.success(response.message, '', {
            'closeButton': true,
            'progressBar': true,
            'positionClass': 'toast-top-center'
          });
          
          // Close the modal
          $('#clips-modal').modal('hide');
          
          // Reload the page or update the clips list
          setTimeout(function() {
            window.location.reload();
          }, 1000);
        } else {
          toastr.error(response.message || 'Error deleting clip', '', {
            'closeButton': true,
            'progressBar': true,
            'positionClass': 'toast-top-center'
          });
        }
      },
      error: function(xhr) {
        let message = 'Error deleting clip';
        if (xhr.responseJSON && xhr.responseJSON.message) {
          message = xhr.responseJSON.message;
        }
        toastr.error(message, '', {
          'closeButton': true,
          'progressBar': true,
          'positionClass': 'toast-top-center'
        });
      }
    });
  };


});
